// client/src/modules/workshop/routes.tsx
import React from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '../../components/ProtectedRoute';
import { lazyWithRetry } from '../../lib/lazyWithRetry';

const WorkshopDashboard = lazyWithRetry(() => import('../../pages/Workshop/WorkshopDashboard'));
const OutreachDashboard = lazyWithRetry(() => import('../../pages/Workshop/Outreach/OutreachDashboard'));
const OutreachContacts = lazyWithRetry(() => import('../../pages/Workshop/Outreach/OutreachContacts'));
const OutreachSettings = lazyWithRetry(() => import('../../pages/Workshop/Outreach/OutreachSettings'));
const OutreachLetters = lazyWithRetry(() => import('../../pages/Workshop/Outreach/OutreachLetters'));
const OutreachLetterComposer = lazyWithRetry(() => import('../../pages/Workshop/Outreach/OutreachLetterComposer'));
const DocumentFillList = lazyWithRetry(() => import('../../pages/Workshop/DocumentFill/DocumentFillList'));
const DocumentFillDetail = lazyWithRetry(() => import('../../pages/Workshop/DocumentFill/DocumentFillDetail'));

/**
 * Workshop module routes — relative to /workshop prefix.
 *
 * Per-tool entitlement is enforced inside each page via useWorkshopToolAccess
 * (returns 'no-access' state when the user lacks the grant for the tool).
 */
export const routes: RouteObject[] = [
  { index: true, element: <ProtectedRoute><WorkshopDashboard /></ProtectedRoute> },
  { path: 'outreach', element: <ProtectedRoute requireManagerOrAdmin><OutreachDashboard /></ProtectedRoute> },
  { path: 'outreach/contacts', element: <ProtectedRoute requireManagerOrAdmin><OutreachContacts /></ProtectedRoute> },
  { path: 'outreach/settings', element: <ProtectedRoute requireManagerOrAdmin><OutreachSettings /></ProtectedRoute> },
  { path: 'outreach/letters', element: <ProtectedRoute requireManagerOrAdmin><OutreachLetters /></ProtectedRoute> },
  { path: 'outreach/letters/new', element: <ProtectedRoute requireManagerOrAdmin><OutreachLetterComposer /></ProtectedRoute> },
  { path: 'outreach/letters/:letterId', element: <ProtectedRoute requireManagerOrAdmin><OutreachLetterComposer /></ProtectedRoute> },
  { path: 'docfill', element: <ProtectedRoute requireManagerOrAdmin><DocumentFillList /></ProtectedRoute> },
  { path: 'docfill/:requestId', element: <ProtectedRoute requireManagerOrAdmin><DocumentFillDetail /></ProtectedRoute> },
];
